import {
  FETCH_SEARCHED_CONTACTS_FAILURE,
  FETCH_SEARCHED_CONTACTS_REQUEST,
  FETCH_SEARCHED_CONTACTS_SUCCESS,
  RESET_SEARCHED_CONTACTS,
} from '../actions/crm';

const initialState = {
  errors: null,
  isSearching: false,
  searchedContacts: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SEARCHED_CONTACTS_REQUEST:
      return {
        ...state,
        errors: null,
        isSearching: true,
      };
    case FETCH_SEARCHED_CONTACTS_SUCCESS:
      return {
        ...state,
        isSearching: false,
        searchedContacts: action.payload.results || [],
      };
    case FETCH_SEARCHED_CONTACTS_FAILURE:
      return {
        ...state,
        errors: action.payload,
        isSearching: false,
        searchedContacts: [],
      };
    case RESET_SEARCHED_CONTACTS:
      return {
        ...state,
        searchedContacts: [],
      };
    default:
      return state;
  }
};
